<template>
  <div class="contract-deliver-bd">
    <div class="change-title ub ub-sp">
      <el-radio-group v-model="formSearch.orgType" @change="onPageChange({ page: 1 })" style="vertical-align: top">
        <el-radio-button label>{{ $t('Common.com_all') }}</el-radio-button>
        <el-radio-button label="HQ">{{ $t('crm_contract_deliver.zong_bu') }}</el-radio-button>
        <el-radio-button label="SC">{{ $t('crm_contract_deliver.shou_hou_gong_si') }}</el-radio-button>
      </el-radio-group>
      <custom-date-picker
        v-model="dataTimes"
        type="datetimerange"
        align="right"
        value-format="YYYY-MM-DD HH:mm:ss"
        :default-time="['00:00:00', '23:59:59']"
        :picker-options="beforeToday"
        unlink-panels
        range-separator="——"
        :start-placeholder="$t('crm_contract_deliver.kai_shi_ri_qi')"
        :end-placeholder="$t('crm_contract_deliver.jie_shu_ri_qi')"
        style="width: 260px; margin-left: 16px"
        @change="onChangeDate()"
      ></custom-date-picker>
    </div>
    <div class="table-bd">
      <custom-table index :data="tableList" tableCode="contractDeliver" @sort-change="sortChange" @filter-change="filterChange"></custom-table>
    </div>
    <div class="table-page">
      <custom-page :total="totalRows" :page="formSearch.pageNum" :size="formSearch.pageSize" @change="onPageChange"></custom-page>
    </div>
  </div>
</template>

<script>
import apis from '@/utils/apis';

export default {
  name: '',
  props: {
    detail: {
      type: Object,
      default() {
        return {};
      },
    },
    rule: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  data() {
    return {
      contractStatus: 'all',
      formSearch: {
        bizId: '',
        bizClass: '',
        orgType: '',
        orderBy: '',
        orderType: '',
        pageSize: 20,
        pageNum: 1,
        outStartDate: undefined,
        outEndDate: undefined,
      },
      dataTimes: [],

      tableList: [],
      totalRows: 0,
      classMap: {
        trail_order: 10, // 试用订单
        leasing_contract: 20, // 租赁合同
        lease_renewal_contract: 21, // 续租租赁
        frame_contract: 30, // 框架协议
        frame_order: 31, // 协议订单
        lease_sales_order: 40, // 租售订单
      },
    };
  },
  mounted: function () {
    this.formSearch.bizId = this.getJump('contractId');
    this.formSearch.bizClass = this.getJump('contractClass');
    this.approveType = this.getJump('approveType');
    if (this.approveType && !this.formSearch.bizClass) {
      this.formSearch.bizClass = this.classMap[this.approveType];
    }
    this.getTableList();
    this.getFuncView();
  },
  methods: {
    // 获取表格数据列表
    getTableList: function () {
      this.$getJSON(apis.ContractOutPage, this.formSearch).then((res) => {
        this.tableList = res.data.list;
        this.totalRows = res.data.total;
      });
    },
    // 分页变更
    onPageChange: function ({ page, size }) {
      this.formSearch.pageNum = page;
      this.formSearch.pageSize = size || this.formSearch.pageSize;
      this.getTableList();
    },
    // 日期范围
    onChangeDate: function () {
      this.formSearch.outStartDate = this.dataTimes && this.dataTimes[0] ? this.dataTimes[0] : undefined;
      this.formSearch.outEndDate = this.dataTimes && this.dataTimes[1] ? this.dataTimes[1] : undefined;
      this.onPageChange({ page: 1 });
    },
  },
};
</script>

<style lang="scss">
@import 'style/colors.scss';

.contract-deliver-bd {
  background-color: #ffffff;
  padding: 0 24px;
  .change-title {
    padding: 24px 0;
  }
}
</style>
